// If type wrong url, route redirect to (404 page not found page) here
<template>
  <div class="flex justify-center content-center flex-wrap h-screen">
    <img
      class="md:pl-6"
      src="@/assets/images/404page.gif"
      style="height:327px"
    />
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
